export type VideoSectionKey = 'video5' | 'video6' | 'video7' | 'video8';

interface VideoSectionConfigParams {
    key: VideoSectionKey;
}

export interface VideoSectionConfig {
    moduleText: string;
    sectionId: string;
    triggerSelector: string;
    videoSrc: string;
    posterSrc: string;
}

export const videoSectionConfigs = (key: VideoSectionConfigParams): VideoSectionConfig => {
    const configMap = {
        video5: {
            moduleText: 'CoverSection1',
            sectionId: 'videoSection5',
            triggerSelector: '#videoSection5',
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1759041204443/01.mp4',
            posterSrc: 'https://websiteoss.ecoflow.com/figma-uploads/1758788341638-67qs8v-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
        },
        video6: {
            moduleText: 'CoverSection2',
            sectionId: 'videoSection6',
            triggerSelector: '#videoSection6',
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1759041204944/02.mp4',
            posterSrc: 'https://websiteoss.ecoflow.com/figma-uploads/1758788341638-67qs8v-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
        },
        video7: {
            moduleText: 'CoverSection3',
            sectionId: 'videoSection7',
            triggerSelector: '#videoSection7',
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1759041205194/03.mp4',
            posterSrc: 'https://websiteoss.ecoflow.com/figma-uploads/1758788388757-f7itxc-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
        },
        video8: {
            moduleText: 'CoverSection4',
            sectionId: 'videoSection8',
            triggerSelector: '#videoSection8',
            videoSrc: 'https://websiteoss.ecoflow.com/upload/video/1759041204643/04.mp4',
            posterSrc: 'https://websiteoss.ecoflow.com/figma-uploads/1758788517599-01vcp7-compressed-%E9%94%80%E5%94%AE%E6%A8%A1%E5%9D%97.jpg',
        },
    };

    return configMap[key] || {};
};
